import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import {
  ApiClientService,
  ApiResponse
} from '../../shared/services/api-client.service';
import { AB_API_BANK_BY_BIC } from '../../shared/constants';

interface BankByBICResponse extends ApiResponse {
  id: string;
  bicCode: string;
  branchCode: string;
  name: string;
  branch: string;
  address: string;
  postCode: string;
  city: string;
  countryCode: string;
  country: string;
}

@Injectable({
  providedIn: 'root'
})
export class BankByBICService extends ApiClientService {
  constructor(http: HttpClient) {
    super(http, AB_API_BANK_BY_BIC);
  }

  getBankByBIC(BIC: string): Observable<BankByBICResponse> {
    return this.get({ bic: BIC });
  }
}

export { BankByBICResponse };
